<template>
  <div v-if="isLoading">
    <b-row>
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
  </div>
  <div v-else class="animated fadeIn pt-1">
    <b-row>
      <b-col md="12">
        <component-header
          title="Features"
          :hasSearch="true"
          :hasReload="true"
          :isLoading="isLoading"
          @reload-data="fetchFeatureList"
          createButtonText="Add Feature"
          @search-query="(val) => (filter = val)"
          @create-press="onClickAddFeature"
          :hasback="false"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <div>
          <b-card border-variant="info">
            <b-table
              style="border-radius: 12px"
              responsive
              :items="tableData"
              :fields="tableFields"
              :current-page="currentPage"
              :per-page="perPage"
              thead-class="header"
              show-empty
              :no-border-collapse="true"
              :filter="filter"
              :busy="isLoading"
              @filtered="onFilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template slot="empty">
                <div v-if="isLoading" class="text-center">
                  <span><b>Loading...</b></span>
                </div>
                <div v-else class="text-center">No data available.</div>
              </template>
              <template slot="Action" slot-scope="data">
                <div class="d-flex">
                  <div>
                    <b-button
                      size="sm"
                      class="button-circle mr-2"
                      @click="onClickView(data.item)"
                      variant="primary"
                    >
                      <i class="fa fa-eye"></i>
                    </b-button>
                  </div>
                  <div class="pl-1">
                    <b-button
                      @click="onClickEdit(data.item)"
                      size="sm"
                      class="button-circle mr-1"
                      style="background: #fe7b08; border: #fe7b08"
                      variant="primary"
                    >
                      <i class="fa fa-pencil"></i>
                    </b-button>
                  </div>
                  <div class="pl-1">
                    <b-button
                      size="sm"
                      class="button-circle mr-2"
                      @click="deleteFeature(data.item)"
                      variant="danger"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </div>
                </div>
              </template>
            </b-table>
          </b-card>
        </div>
        <div class="pagination_mainDiv">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
import ebButton from "@/components/FormElements/Button";

export default {
  name: "features",
  props: {},
  components: {
    ebSelect,
    ebButton,
    ComponentHeader,
    AtomSpinner,
  },
  data() {
    return {
      isLoading: false,
      searchQuery: "",
      filterCount: 0,
      filter: "",
      sortBy: "createdAt",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      tableFields: [
        {
          label: "Feature Name",
          key: "name",
        },
        {
          label: "Description",
          key: "description",
          formatter: "shortDescription",
          class: "textAlignment",
        },
        {
          label: "Permission Added",
          key: "permission",
          formatter: "NoOfPermissions",
        },
        {
          label: "Action",
          key: "Action",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      allFeatureList: (state) => state.feature.featureList,
    }),
    tableData() {
      return this.allFeatureList;
    },
  },
  methods: {
    shortDescription(value) {
      if (value.length > 210) {
        return value.slice(0, 210) + "...." || "";
      }
      return value;
    },
    async fetchFeatureList() {
      this.isLoading = true;
      await this.$store.dispatch("feature/fetchFeatureList");
      this.isLoading = false;
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    onClickAddFeature() {
      this.$router.push({ path: "/features/addFeature" });
    },
    onClickEdit(data) {
      this.$router.push({ name: "edit-feature", params: { id: data._id } });
    },
    onClickView(data) {
      this.$router.push({ name: "view-feature", params: { id: data._id } });
    },
    NoOfPermissions(value) {
      return value.length;
    },
    async deleteFeature(data) {
      await this.$swal({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Delete"
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("feature/deleteFeature", data._id)
            .then((result) => {
              this.$toasted.success("Feature Deleted Successfully");
              this.$store
                .dispatch("feature/fetchFeatureList")
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
          this.isLoading = false;
        }
      });
    },
  },
  async mounted() {
    this.fetchFeatureList();
  },
};
</script>

<style>
.pagination_mainDiv {
  float: right;
}
.table td {
  text-align: center;
  border-right: 1px solid #e8e5e5;
}
tbody tr:nth-child(2n + 1) {
  border-bottom: 1px solid #e8e5e5;
}

td.textAlignment {
  text-align: justify !important;
  white-space: pre-wrap;
}
</style>
